export default "__VITE_ASSET__DJ0AnYD0__"